/* eslint-disable prefer-const */
import React, { useEffect, useState, DragEvent } from 'react';
import ReactFlow, {
  ReactFlowProvider,
  addEdge,
  ReactFlowInstance,
  Connection,
  Edge,
  Node,
  useNodesState,
  useEdgesState,
  useReactFlow,
  Controls,
  Background,
  OnSelectionChangeParams,
  ReactFlowJsonObject,
} from 'react-flow-renderer';

import './dnd.css';
import { WorkflowsService } from 'shared/services/workflows/workflowsService';
import { useSelectedOrganization } from 'shared/store/organization';
import { useNavigate, useParams } from 'react-router-dom';
import ShortUniqueId from 'short-unique-id';
import { CampanhaNode, InicioNode, FimNode, SleepNode, CondicionalNode, ValidacaoModal } from 'shared/components/CustomFlowNodes';
import ComponenteDetalhe from 'shared/components/CustomFlowNodes/ComponenteDetalhe';
import { AlertColor, Box, CircularProgress, Typography } from '@mui/material';
import theme from 'shared/themes/theme';
import { CampanhasService } from 'shared/services/campanhas/campanhasService';
import { IListagemCampanhaSimples, IListagemCanal, IListagemCondicionaisRetorno, IListagemFornecedora, IRespFluxoValidacao, listKeyValueStatus } from 'shared/types';
import * as R from 'ramda';
import { CondicionaisRetornoService } from 'shared/services/condicionaisRetorno/condicionaisRetornoService';
import { CanaisService } from 'shared/services/canais/canaisService';
import { FornecedorasService } from 'shared/services/fornecedoras/fornecedorasService';
import { AlertaSnackBar } from 'shared/components';
import { getValueFromKeyValue, stringToDateTime } from 'shared/utils';
import Sidebar from 'shared/components/CustomFlowNodes/Sidebar';
import { AlteracaoStatusModal } from 'shared/components/CustomFlowNodes/AlteracaoStatusModal';
import { Environment } from 'shared/environment';
import { useIsDrawerMenuOpen } from 'shared/store/drawer';
import { useHasPermissionAcao } from 'shared/hooks';

const initialNodes: Node[] = [];


const onDragOver = (event: DragEvent) => {
  event.preventDefault();
  event.dataTransfer.dropEffect = 'move';
};

const nodeTypes = {
  campanha: CampanhaNode,
  inicio: InicioNode,
  fim: FimNode,
  condicional: CondicionalNode,
  sleep: SleepNode,
};

const uid = new ShortUniqueId({ length: 10 });

const getId = (type: string) => `${type}_${uid()}`;

const Workflow: React.FC = () => {
  const [reactFlowInstance, setReactFlowInstance] = useState<ReactFlowInstance>();
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const { setViewport } = useReactFlow();
  const { id } = useParams<'id'>();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [elemento, setElemento] = useState<OnSelectionChangeParams | null>();
  const org = useSelectedOrganization();
  const navigate = useNavigate();
  const isDrawerMenuOpen = useIsDrawerMenuOpen();

  const [nome, setNome] = useState('');
  const [descricao, setDescricao] = useState('');
  const [tipoEdge, setTipoEdge] = useState('');
  const [idCampanha, setIdCampanha] = useState('');
  const [idCanal, setIdCanal] = useState('');
  const [idFornecedora, setIdFornecedora] = useState('');
  const [idCondicionalRetorno, setIdCondicionalRetorno] = useState<string[]>(['']);
  const [textoCondicionalRetorno, setTextoCondicionalRetorno] = useState<string[]>(['']);
  const [tempoSleep, setTempoSleep] = useState(15);
  const [workflow, setWorkflow] = useState({
    StatusWorkflow: '',
    DhPeriodoInicio: '',  
    DhPeriodoFim: ''
  });

  const [openAlterarStatus,setOpenAlterarStatus] = useState(false);
  const [statusAlteracao, setStatusAlteracao] = useState('');

  const [stateSnack, setStateSnack] = useState({
    open: false,
    severity: 'success',
    message: '',
  });
  
  const [validacaoOpen, setValidacaoOpen] = useState(false);
  const [respValidacao, setRespValidacao] = useState<IRespFluxoValidacao>();
  
  const [listCampanhas, setListCampanhas] = useState<IListagemCampanhaSimples[]>([]);
  const [listCanais, setListCanais] = useState<IListagemCanal[]>([]);
  const [listFornecedores, setListFornecedores] = useState<IListagemFornecedora[]>([]);

  const [listCondicionaisRetorno, setListCondicionaisRetorno] = useState<IListagemCondicionaisRetorno[]>([]);

  const hasPermitionUpdate = useHasPermissionAcao('workflow','UPD');

  useEffect(() => {
    setIsLoading(true);
    WorkflowsService.getFluxo(Number(org?.CodigoOrganizacao), Number(id))
      .then((result) => {
        if (result instanceof Error) {
          setStateSnack({open:true, severity:'error',message:`Ocorreu o seguinte erro: ${result.message}`});
        } else {
          setNodes(result.nodes || []);
          setEdges(result.edges || []);
          setViewport(result.viewport);
          setWorkflow({StatusWorkflow: result.StatusWorkflow, DhPeriodoInicio: result.DhPeriodoInicio, DhPeriodoFim: result.DhPeriodoFim });
        }
        setIsLoading(false);
      });
    CanaisService.getByOrg(Number(org?.CodigoOrganizacao))
      .then((result) => {
        if (result instanceof Error) {
          setStateSnack({open:true, severity:'error',message:`Ocorreu o seguinte erro: ${result.message}`});
        } else {
          setListCanais(result);
        }
      });

    FornecedorasService.getOrg(Number(org?.CodigoOrganizacao))
      .then((result) => {
        if (result instanceof Error) {
          setStateSnack({open:true, severity:'error',message:`Ocorreu o seguinte erro: ${result.message}`});
        } else {
          setListFornecedores(result);
        }
      });

    CondicionaisRetornoService.getAll(Number(org?.CodigoOrganizacao))
      .then((result) => {
        if (result instanceof Error) {
          setStateSnack({open:true, severity:'error',message:`Ocorreu o seguinte erro: ${result.message}`});
        } else {
          setListCondicionaisRetorno(result);
        }
      });
  }, []);

  
  useEffect(() => {
    if(workflow.StatusWorkflow !== ''){
      setStatusAlteracao(`${workflow.StatusWorkflow}     `.substring(0,5));
      if(workflow.StatusWorkflow.trim() === 'INAT' && hasPermitionUpdate)
        setIsEditable(true);
      else
        setIsEditable(false);
      const filtro = `?stCampanha=""&dtInicio=${workflow.DhPeriodoInicio}&dtFim=${workflow.DhPeriodoFim}`;
      CampanhasService.getSimples(Number(org?.CodigoOrganizacao), filtro)
        .then((result) => {
          if (result instanceof Error) {
            setStateSnack({open:true, severity:'error',message:`Ocorreu o seguinte erro: ${result.message}`});
          } else {
            setListCampanhas(result);
          }
        });
    }
  }, [workflow]);

  
  const onConnect = (params: Connection | Edge) => {
    const newParams: Edge = {
      id: getId('edge'),
      label: '',
      source: params.source as string,
      sourceHandle: params.sourceHandle,
      target: params.target as string,
      targetHandle: params.targetHandle,
      type: 'smoothstep',
      data: {
        descricao: ''
      },
    };
    removeEdgeHandle(params.source as string, params.sourceHandle as string, params.target as string, params.targetHandle as string);
    setEdges((eds) => addEdge(newParams, eds));
  };

  const onDrop = (event: DragEvent) => {
    event.preventDefault();

    if (reactFlowInstance && isEditable) {
      const type = event.dataTransfer.getData('application/reactflow');
      let inclui = true;
      if (type !== 'inicio' && type !== 'fim' && type !== 'campanha' && type !== 'campanhaOnl'  &&
          type !== 'condicional' && type !== 'sleep' )
        inclui = false;
      const position = reactFlowInstance.project({ x: event.clientX - 180 , y: event.clientY - 80 });


      if (inclui) {
        const isCmpOnline: boolean = type === 'campanhaOnl';
        const newNode: Node = {
          id: getId(type),
          type: isCmpOnline ? 'campanha' : type,
          position,
          data: {
            label: type,
            descricao: '',
            cmpOnline: isCmpOnline,
            sleepTime: type === 'sleep'?tempoSleep:0
          },
        };
        setNodes((nds) => nds.concat(newNode));
      }

    }
  };

  const onSelectChange = (parm: OnSelectionChangeParams) => {
    if (parm.nodes.length === 0 && parm.edges.length === 0) {
      setElemento(null);
    } else {
      setElemento(parm);
      if (parm.nodes.length > 0) {
        setNome(parm.nodes[0].data.label);
        setDescricao(parm.nodes[0].data.descricao);
        setIdCampanha(parm.nodes[0].data.campanhaId ? parm.nodes[0].data.campanhaId : '');
        setIdCanal(parm.nodes[0].data.condicionalCanal ? parm.nodes[0].data.condicionalCanal : '');
        setIdFornecedora(parm.nodes[0].data.condicionalFornec ? parm.nodes[0].data.condicionalFornec : '');
        setIdCondicionalRetorno(parm.nodes[0].data.condicionalRetorno ? parm.nodes[0].data.condicionalRetorno : []);
        if(parm.nodes[0].data.condicionalRetorno){
          if(parm.nodes[0].data.textoCondicionalRetorno ){
            setTextoCondicionalRetorno(parm.nodes[0].data.textoCondicionalRetorno);
            if(parm.nodes[0].data.condicionalRetorno.length !== parm.nodes[0].data.textoCondicionalRetorno.length){
              const dif = parm.nodes[0].data.condicionalRetorno.length - parm.nodes[0].data.textoCondicionalRetorno.length;
              if(dif > 0){
                for(let n = 0; n < dif; n++){
                  setTextoCondicionalRetorno([...textoCondicionalRetorno, '']);
                }
              }
            }
          }
          else{
            setTextoCondicionalRetorno([]);
            while(textoCondicionalRetorno.length < idCondicionalRetorno.length){
              setTextoCondicionalRetorno([...textoCondicionalRetorno, '']);
            }
          }
        }
        else
          setTextoCondicionalRetorno([]);
        
        setTempoSleep(parm.nodes[0].data.sleepTime ? parm.nodes[0].data.sleepTime : 15);
      }
      else {
        setNome(parm.edges[0].label === null ? '' : parm.edges[0].label ? parm.edges[0].label as string : '');
        setDescricao('');
        setTipoEdge(parm.edges[0].type === null ? '' : parm.edges[0].type ? parm.edges[0].type as string : '');
      }


    }

  };

  const limparBadgesErros = () => {
    setNodes((nds) =>
      nds.map((node) => {
        node.data = {
          ...node.data,
          erros:0
        };
        return node;
      })
    );
  };
  
  const marcarBadgesErros = (elmId: string) => {
    const nodesNovo = nodes.map((node) => {
      const numErros =  node.data.erros + 1;
      if (node.id === elmId) {
        node.data = {
          ...node.data,
          erros:numErros
        };
      }
      return node;
    });
    setNodes(nodesNovo);
  };

  const validarFlow = () => {
    if (reactFlowInstance) {
      setIsSubmitting(true);
      const flow = reactFlowInstance.toObject();
      WorkflowsService.validateFluxo(Number(org?.CodigoOrganizacao), Number(id), flow, '')
        .then((result) => {
          if (result instanceof Error) {
            setStateSnack({open:true, severity:'error',message:`Ocorreu o seguinte erro: ${result.message}`});
          } else {
            limparBadgesErros();
            setValidacaoOpen(true);
            setRespValidacao(result);
                
            if(result.resultado === 'OK'){
              setStateSnack({open:true, severity:'success',message:'Fluxo Validado com sucesso!'});
            }
            else
            {
              if(result.erros){
                result.erros.map((err) => {
                  marcarBadgesErros(err.idComponente);
                });
              } 
            }
            
          }
        })
        .catch((error) =>{
          setStateSnack({open:true, severity:'error',message:`Não foi possível validar o Fluxo! Ocorreu o seguinte erro: ${error}`});
        })
        .finally(() => setIsSubmitting(false));
    }
  };


  const saveFlow = () => {
    if (reactFlowInstance) {
      setIsSubmitting(true);
      const flow = reactFlowInstance.toObject();
      WorkflowsService.updateFluxo(Number(org?.CodigoOrganizacao), Number(id), flow)
        .then(() => {
          setStateSnack({open:true, severity:'success',message:'Fluxo salvo com sucesso!'});
        })
        .catch((error) =>{
          setStateSnack({open:true, severity:'error',message:`Não foi possível atualizar o Fluxo! Ocorreu o seguinte erro: ${error}`});
        })
        .finally(() => setIsSubmitting(false));
    }
  };

  const buscaCampanhaSelecionada = (idCampanha: string): IListagemCampanhaSimples | null => {
    let campanhaSel = null;
    listCampanhas.map((campanha) => {
      if (campanha.IdCampanha.toString() == idCampanha)
        campanhaSel = campanha;
    });
    return campanhaSel;
  };

  const buscaCanalSelecionado = (idCanal: string): IListagemCanal | null => {
    let canalSel = null;
    listCanais.map((canal) => {
      if (canal.IdCanal.toString() == idCanal)
        canalSel = canal;
    });
    return canalSel;
  };

  const buscaFornecedoraSelecionada = (idCanal: string, idFornecedora: string): IListagemFornecedora | null => {
    let fornecedoraSel = null;
    listFornecedores.map((fornecedora) => {
      if (fornecedora.IdFornecedora === Number(idFornecedora) && fornecedora.IdCanal === Number(idCanal) )
        fornecedoraSel = fornecedora;
    });
    return fornecedoraSel;
  };

  const buscaNomesCondicionaisRetorno = (idCanal: string, idFornecedora: string, condListId: string[]): string => {
    let nomes = '';
    condListId.map((condId) => {
      listCondicionaisRetorno.map((cond) => {
        if (cond.IdCanal === Number(idCanal) && cond.IdFornecedora === Number(idFornecedora) && cond.IdCondicionalRetorno === Number(condId)) {
          nomes = `${nomes}${nomes === '' ? '' : ','}${cond.NomeCondicionalRetorno}`;
        }
      });
    });
    return nomes;
  };

  const montaCondicionaisResposta = (idCanal: string, idFornecedora: string, condListId: string[]): string[] => {
    let nomes:string[] = [];
    condListId.map((condId) => {
      listCondicionaisRetorno.map((cond) => {
        if (cond.IdCanal === Number(idCanal) && cond.IdFornecedora === Number(idFornecedora) && cond.IdCondicionalRetorno === Number(condId)) {
          nomes.push(cond.TipoCondicionalRetorno);
        }
      });
    });
    return nomes;
  };

  const removeEdge = (idNode: string) => {
    const filterEdges = R.filter(
      (edge) => (edge.source !== idNode && edge.target !== idNode),
      edges
    );
    setEdges(filterEdges);
  };

  const removeEdgeHandle = (source:string, sourceHandle: string, target: string, targetHandle: string) => {
    const filterEdges = R.filter(
      (edge) => !((edge.source === source && edge.sourceHandle === sourceHandle) 
      || (edge.target === target && edge.targetHandle === targetHandle && R.split('_', edge.target as string)[0] !== 'fim') )
      ,edges
    );
    setEdges(filterEdges);
  };
  
  const removeEdgeOrfao = (idNode: string) => {
    const filterEdges = R.filter(
      (edge) => edge.source !== idNode,
      edges
    );
    setEdges(filterEdges);
  };

  const handleAtualizarComponente = (isNodeAtz: boolean, elmId: string) => {
    if (isNodeAtz) {
      setNodes((nds) =>
        nds.map((node) => {
          if (node.id === elmId) {
            switch (node.type) {
            case 'campanha':
            {
              const campanhaSel = buscaCampanhaSelecionada(idCampanha);
              if (campanhaSel?.IdCampanha !== node.data.campanhaId) {
                removeEdge(node.id);
              }
              node.data = {
                ...node.data,
                label: nome,
                descricao: descricao,
                campanhaId: idCampanha,
                campanhaNome: campanhaSel?.NomeCampanha,
                campanhaCanais: campanhaSel?.ListaCanalFornecedora,
              };
              break;
            }
            case 'condicional':
            {
              const canalSel = buscaCanalSelecionado(idCanal);
              const fornecedoraSel = buscaFornecedoraSelecionada(idCanal,idFornecedora);
              if (idCanal !== node.data.condicionalCanal ||
                idFornecedora !== node.data.condicionalFornec) {
                removeEdge(node.id);
              }
              if (idCanal === node.data.condicionalCanal &&
                idFornecedora === node.data.condicionalFornec &&
                idCondicionalRetorno !== node.data.condicionalRetorno) {
                removeEdgeOrfao(node.id);
              }
              node.data = {
                ...node.data,
                label: nome,
                descricao: descricao,
                condicionalCanal: idCanal,
                condicionalFornec: idFornecedora,
                condicionalRetorno: idCondicionalRetorno,
                textoCondicionalRetorno: textoCondicionalRetorno,
                condicionalInput: `${canalSel?.NomeCanal}/${fornecedoraSel?.NomeFornecedora}`,
                condicionalOutput: buscaNomesCondicionaisRetorno(idCanal,idFornecedora,idCondicionalRetorno),
                condicionalResposta: montaCondicionaisResposta(idCanal,idFornecedora,idCondicionalRetorno)

              };
              break;
            }
            case 'sleep':
            {
              node.data = {
                ...node.data,
                label: nome,
                descricao: descricao,
                sleepTime: tempoSleep,
              };
              break;
            }
            default:
              node.data = {
                ...node.data,
                label: nome,
                descricao: descricao,
              };
              break;
            }
          }
          return node;
        })
      );
      setStateSnack({open:true, severity:'success',message:'Componente atualizado com sucesso!'});
    } else {
      setEdges((edg) =>
        edg.map((edge) => {
          if (edge.id === elmId) {
            edge.label = nome;
            edge.type = tipoEdge;
          }
          return edge;
        })
      );
      setStateSnack({open:true, severity:'success',message:'Ligação atualizada com sucesso!'});
    }
  };

  const addCondicionalRet = () => {
    setIdCondicionalRetorno([...idCondicionalRetorno, '']);
    setTextoCondicionalRetorno([...textoCondicionalRetorno, '']);
  };

  const delCondicionalRet = () => {
    idCondicionalRetorno.pop();
    setIdCondicionalRetorno([...idCondicionalRetorno]);
    textoCondicionalRetorno.pop();
    setTextoCondicionalRetorno([...textoCondicionalRetorno]);
  };

  const handleChangeCondicionalRet = (value: string, index: number) => {
    let inputRet:string[] = [...idCondicionalRetorno];
    inputRet[index] = value.toString();
    setIdCondicionalRetorno(inputRet);
    let inputTxtRet:string[] = [...textoCondicionalRetorno];
    inputTxtRet[index] = '';
    setTextoCondicionalRetorno(inputTxtRet);
  };

  const handleChangeTextoCondicionalRet = (value: string, index: number) => {
    let inputRet:string[] = [...textoCondicionalRetorno];
    inputRet[index] = value.toString();
    setTextoCondicionalRetorno(inputRet);
  };

  const handleCloseSnack = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setStateSnack({...stateSnack, open:false});
  };

  const handleCLoseValidacaoModel = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setValidacaoOpen(false);
  };

  const alterarStatus = () => {
    setOpenAlterarStatus(true);
  };

  const handleAlterarStatus= () => {
    if (statusAlteracao.trim().toUpperCase() !== 'INAT'){
      if (reactFlowInstance) {
        setIsSubmitting(true);
        const flow = reactFlowInstance.toObject();
        WorkflowsService.validateFluxo(Number(org?.CodigoOrganizacao), Number(id), flow, statusAlteracao)
          .then((result) => {
            if (result instanceof Error) {
              setStateSnack({open:true, severity:'error',message:`Ocorreu o seguinte erro: ${result.message}`});
            } else {
              limparBadgesErros();
              setValidacaoOpen(true);
              setRespValidacao(result);
                  
              if(result.resultado === 'OK'){
                alterarStatusWorkflow(statusAlteracao,flow);
              }
              else
              {
                if(result.erros){
                  result.erros.map((err) => {
                    marcarBadgesErros(err.idComponente);
                  });
                } 
              }
            }
          })
          .catch((error) =>{
            setStateSnack({open:true, severity:'error',message:`Não foi possível validar o Fluxo! Ocorreu o seguinte erro: ${error}`});
          })
          .finally(() => setIsSubmitting(false));
      }
    }
    else{
      if (reactFlowInstance) {
        const flow = reactFlowInstance.toObject();
        alterarStatusWorkflow(statusAlteracao, flow);  
      }
    }
            
  };

  const alterarStatusWorkflow = (statusAlteracao:string,flow:ReactFlowJsonObject<any, any>) =>{
    
    setIsSubmitting(true);
    WorkflowsService.updateStatus(Number(org?.CodigoOrganizacao), Number(id), statusAlteracao, flow)
      .then((result) => {
        if (result instanceof Error) {
          setStateSnack({open:true, severity:'error',message:`Ocorreu o seguinte erro: ${result.message}`});
        } else {
          setWorkflow({...workflow, StatusWorkflow:statusAlteracao});
          //salvar fluxo
          WorkflowsService.updateFluxo(Number(org?.CodigoOrganizacao), Number(id), flow);
          setStateSnack({open:true, severity:'success',message:'Status Workflow atualizado com sucesso!'});
        }
      })
      .catch((error) =>{
        setStateSnack({open:true, severity:'error',message:`Não foi possível atualizar o status do workflow! Ocorreu o seguinte erro: ${error}`});
      })
      .finally(() => {
        setIsSubmitting(false);
        setOpenAlterarStatus(false);
      });
    
  };
  
  return (
    <Box className='dndflow' marginLeft={`${isDrawerMenuOpen?Environment.TAMANHO_DO_DRAWER_MENU:0}px`} >
      <Sidebar
        isEditable={isEditable}
        canChangeStatus={hasPermitionUpdate}
        status={ getValueFromKeyValue(listKeyValueStatus, workflow.StatusWorkflow) }
        handleAlterarStatus={alterarStatus}
        handleValidar={validarFlow}
        handleSalvar={saveFlow}
        handleVoltar={() => navigate(`/workflow/detalhe/${id}`)}
      />
      <Box className="reactflow-wrapper" >
        {!(isLoading || isSubmitting) && (<ReactFlow
          nodes={nodes}
          edges={edges}
          onEdgesChange={onEdgesChange}
          onNodesChange={onNodesChange}
          onConnect={onConnect}
          onInit={setReactFlowInstance}
          onDrop={onDrop}
          onDragOver={onDragOver}
          style={{ width: '100%', height: `calc(100vh - ${theme.spacing(20)})` }}
          nodeTypes={nodeTypes}
          deleteKeyCode={isEditable?['Backspace', 'Delete']:[]}
          onSelectionChange={(parm) => onSelectChange(parm)}
          className='validationflow'
          connectOnClick={false}
          zoomOnDoubleClick={false}
          nodesConnectable={isEditable}
          nodesDraggable={isEditable}
        >
          <Box style={{ position: 'absolute', left: 10, top: 10,  border: '1px solid #222138', borderRadius: '15px' }}>
            <Box margin={2}>
              <Typography style={{fontSize: '10pt'}}>WorkFlow</Typography >
              <Typography marginLeft={2} style={{fontSize: '10pt'}}>Id: {id}</Typography >
              <Typography marginLeft={2} style={{fontSize: '10pt'}}>Período</Typography >
              <Typography marginLeft={4} style={{fontSize: '10pt'}}>Início: {stringToDateTime(workflow.DhPeriodoInicio)}</Typography >
              <Typography marginLeft={4} style={{fontSize: '10pt'}}>Fim: {stringToDateTime(workflow.DhPeriodoFim)}</Typography >
            </Box>
          </Box>
          <Controls showInteractive={isEditable}/>
          <Background color="#aaa" gap={16} />
        </ReactFlow>)}
        {(isLoading || isSubmitting) && (<Box sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <CircularProgress />
        </Box>)}
      </Box>
      {elemento && (<ComponenteDetalhe
        elemento={elemento}
        nome={nome}
        descricao={descricao}
        tipo={tipoEdge}
        campanha={idCampanha}
        canal={idCanal}
        fornecedora={idFornecedora}
        condicionalRetorno={idCondicionalRetorno}
        textoCondicionalRetorno={textoCondicionalRetorno}
        sleep={tempoSleep}
        isEditable={isEditable}
        listCampanha={listCampanhas.map((itemk) => itemk)}
        listCanais={listCanais.map((itemk) => itemk)}
        listFornecedora={listFornecedores.map((itemk) => itemk)}
        listCondicionaisRetorno={listCondicionaisRetorno.map((itemk) => itemk)}
        handleChangeNome={(text) => setNome(text)}
        handleChangeDescricao={(text) => setDescricao(text)}
        handleChangeTipo={(text) => setTipoEdge(text)}
        handleChangeCampanha={(text) => setIdCampanha(text)}
        handleChangeCanal={(text) => { setIdCanal(text); setIdFornecedora(''); setIdCondicionalRetorno(['']); setTextoCondicionalRetorno(['']);  }}
        handleChangeFornecedora={(text) => { setIdFornecedora(text); setIdCondicionalRetorno(['']); setTextoCondicionalRetorno(['']);}}
        handleChangeCondicionalRetorno={(text, index) => handleChangeCondicionalRet(text, index)}
        handleChangeTextoCondicionalRetorno={(text, index) => handleChangeTextoCondicionalRet(text, index)}
        handleChangeSleep={(num) => setTempoSleep(num)}
        handleClickAddCondicional={addCondicionalRet}
        handleClickDelCondicional={delCondicionalRet}
        handleClickAtualizar={(isNode, elmId) => handleAtualizarComponente(isNode, elmId)}
      />)}

      <AlertaSnackBar 
        open={stateSnack.open} 
        severity={stateSnack.severity as AlertColor} 
        message={stateSnack.message} 
        handleClose={handleCloseSnack} 
      />
      {respValidacao && (
        <ValidacaoModal
          open={validacaoOpen}
          respValidacao={respValidacao as IRespFluxoValidacao}
          onClose={handleCLoseValidacaoModel}
        />
      )}

      <AlteracaoStatusModal
        open={openAlterarStatus}
        status={statusAlteracao}
        alterado={statusAlteracao !== `${workflow.StatusWorkflow}     `.substring(0,5)}
        onChangeStatus={(status) => setStatusAlteracao(status)}
        onClose={() => {setOpenAlterarStatus(false);setStatusAlteracao(`${workflow.StatusWorkflow}     `.substring(0,5));}}
        onSave={handleAlterarStatus}
      />
    </Box>
  );
};


export const WorkflowCampanha: React.FC = () => (
  <ReactFlowProvider>
    <Workflow />
  </ReactFlowProvider>
  
);